/** Policies that can be renewed/extended */
export const includedPolicies = [
	"MCOTP",
	"MCOTPS",
	"MCOTN",
	"MPCTP",
	"MCPTP",
	"MMCTP",
	"MPCTN",
	"MPCTPS",
	"MPPTP",
	"MPPTPB",
	"MPPTPBS",
	"MPPTPS",
	"MLXC",
	"MLXCC",

	"CBSS",
	"MCOC",
	"MCOCS",
	"MCPC",
	"MPCC",
	"MPCCN",
	"MPCCS",
	"MPPC",
	"MPPCB",
	"MPPCBS",
	"MPPCS",
	"MPRC",
	"MUWC",
	"MUWCC",
	"MPRCC",

	"MCOCN",
	"MCOTF",
	"MPCTF",
	"MPPTF",
	"MMCC",

	"MSTTP",
	"MSTC",
	"MSTLF",
	"MSTTF",
];

export const applicableNarratives = [
	"2000",
	"2008",
	"2012",
	"2020",
	"2021",
	"2022",
	"2031",
	"2032",
	"2036",
	"2042",
	"2043",
	"2044",
	"2045",
	"2046",
	"2049",
	"2050",
	"2051",
	"2052",
	"2053",
	"2056",
	"2057",
	"2058",
	"2055",
	"2041",
	"2019",
	"2047",
	"2023",
	"2033",
];

export const homePolicies = [];

export const applicableRiders = {
	pa_rider: ["131", "132", "133", "134", "135" /*, "138A", "139A", "136A" */],
	um_rider: ["140", "141", "142", "143", "144", "145", "147"],
};

export const comprehensiveCodes = [
	"CBSS",
	"MCOC",
	"MCOCS",
	"MCPC",
	"MPCC",
	"MPCCN",
	"MPCCS",
	"MPPC",
	"MPPCB",
	"MPPCBS",
	"MPPCS",
	"MPRC",
	"MUWC",
	"MUWCC",
	"MPRCC",
	"MLXC",
	"MXLXCC",
];

export const comprehensiveAgreedValueCodes = ["MUWC", "MUWCC", "MPRC", "MPRCC", "MLXC", "MXLXCC"];

export const includedComprehensiveNonAgreedPolicies = [
	"CBSS",
	"MCOC",
	"MCOCS",
	"MCPC",
	"MPCC",
	"MPCCN",
	"MPPC",
	"MPPCB",
	"MPPCBS",
	"MPPCS",
	"MPCCS",
];

export const claimAcceptablePolicies = ["NCBMLC"];

export const includedAgreedPolicies = ["MPRCC", "MUWC", "MPRC", "MUWCC"];

export const includedAgreedPoliciesWithGN = [{ prefix: "MPCCS", group_name: "NCBAP" }];

export const thirdPartyCode = [
	"MCOTP",
	"MCOTPS",
	"MCOTN",
	"MPCTP",
	"MCPTP",
	"MMCTP",
	"MPCTN",
	"MPCTPS",
	"MPPTP",
	"MPPTPB",
	"MPPTPBS",
	"MPPTPS",
];

export const PA_death_Disablement = ["131", "132", "133", "134", "135"];

export const uninsured_Motorist = ["140", "141", "142", "143", "144", "146"];

export const applicable_policy_prefix_promo = ["MLXCC", "MLXC", "MPRCC", "MUWC", "MPCC", "MPCTP", "MPRC", "MUWCC"];

export const policy_prefix_list_for_limit_group = [
	"MPCC",
	"MPCTP",
	"MCOC",
	"MCOTP",
	"MCPC",
	"MCPTP",
	"MMCTP"
  ];

  export const city_county_list_for_limit_group = [
	"Bog Walk",
	"Bogwalk",
	"Linstead",
	"Ewarton",
	"Spanish Town"
  ];
  
// Discount Rating Codes
export const DISCOUNT_RATING_CODES = {
  OTHER_VEHICLE: "301",
  RENEWAL: "302",
  CIVIL_SERVANTS: "306",
  OTHER_INSURANCE: "308",
  POLICYHOLDER_OVER_50: "319A",
  POLICYHOLDER_60_OR_OLDER: "319B",
  FEMALE_OWNER_MAIN_DRIVER: "335",
  SAGICOR_CUSTOMER: "338",
  POLICYHOLDER_SPOUSE_ONLY: "342",
  INSURED_2_NAMED_DRIVERS: "343",
  NCB_CUSTOMER: "397",
  INTRODUCTORY: "399",
  BABY_ON_BOARD: "701",

   // No Claim Discounts
  NO_CLAIM_DISCOUNT_20: "402",
  NO_CLAIM_DISCOUNT_30: "405",
  NO_CLAIM_DISCOUNT_40: "407",
  NO_CLAIM_DISCOUNT_50: "409",
  NO_CLAIM_DISCOUNT_60: "411"
};

// Loading Rating Codes
export const LOADING_RATING_CODES = {
  BUSINESS_USE: "200",
  SALES_REPRESENTATIVE: "201",
  COMPANY_REGISTERED_VEHICLE: "202",
  DRIVER_UNDER_21: "204A",
  DRIVER_UNDER_23: "204C",
  DRIVER_UNDER_25_LICENSE_UNDER_2: "204D",
  OCCUPATIONAL_LOADING: "205",
  OCCUPATIONAL_LOADING_P: "205P",
  OPEN_POLICY: "206",
  COMMERCIAL_TRAVELLING: "207",
  MALE_DRIVER_17_45_NOT_CLAIM_FREE: "236",
  NOT_OWNER_DRIVEN: "340"
};

// No Claim Discounts specific constants (for easy reference)
export const NO_CLAIM_DISCOUNT_CODES = {
  TWENTY_PERCENT: "402",
  THIRTY_PERCENT: "405",
  FORTY_PERCENT: "407",
  FIFTY_PERCENT: "409",
  SIXTY_PERCENT: "411"
};

// All Rating Codes (combined for easy reference)
export const ALL_RATING_CODES = {
  ...DISCOUNT_RATING_CODES,
  ...LOADING_RATING_CODES
};

export const UNINSURED_MOTORIST_TABLE = [
  { min: 400000, max: 999999, premium: 2500, description: "Uninsured Vehicle Premium 1", code: "140" },
  { min: 1000000, max: 1999999, premium: 4000, description: "Uninsured Vehicle Premium 2", code: "141" },
  { min: 2000000, max: 3999999, premium: 5000, description: "Uninsured Vehicle Premium 3", code: "142" },
  { min: 4000000, max: 5999999, premium: 6000, description: "Uninsured Vehicle Premium 4", code: "143" },
  { min: 6000000, max: 9999999, premium: 7500, description: "Uninsured Vehicle Premium 5", code: "144" },
  { min: 10000000, max: Infinity, premium: 10000, description: "Uninsured Vehicle Premium 6", code: "145" }
];
// ============================================================================
// VEHICLE POLICY REQUIREMENTS & VALIDATION
// ============================================================================

/**
 * Policy prefixes that have specific vehicle requirements
 * Used in AddNewVehicle to determine eligibility
 */

export const PREFIXES_WITH_POLICY_REQUIREMENTS = new Set(['MUWC', 'MUWCC', 'MPRC', 'MPRCC']);

/**
 * Vehicle requirements per policy type
 * - maxVehicleAge: Maximum age of vehicle in years
 * - minMarketValue: Minimum estimated market value in JMD
 * - maxMarketValue: Maximum estimated market value in JMD
 */
export const POLICY_REQUIREMENTS = {
    MUWC: { maxVehicleAge: 11, minMarketValue: 4000000, maxMarketValue: 19999999 },
    MUWCC: { maxVehicleAge: 11, minMarketValue: 4000000, maxMarketValue: 19999999 },
    MPRC: { maxVehicleAge: 11, minMarketValue: 8000000, maxMarketValue: 19999999 },
    MPRCC: { maxVehicleAge: 11, minMarketValue: 8000000, maxMarketValue: 19999999 }
};

/**
 * Body type restrictions per policy prefix
 * MPRC/MUWC: Passenger vehicles only
 * MPRCC/MUWCC: Commercial vehicles only
 */
export const POLICY_BODY_TYPE_RULES = {
    MPRC: ['Sedan', 'Station Wagon', 'Hatchback', 'Coupe', 'SUV'],
    MUWC: ['Sedan', 'Station Wagon', 'Hatchback', 'Coupe', 'SUV'],
    MPRCC: ['Pickup', 'Van'],
    MUWCC: ['Pickup', 'Van']
};

/**
 * Pre-computed sets for faster body type validation
 * All values normalized to lowercase for case-insensitive comparison
 */
export const POLICY_BODY_TYPE_RULE_SETS = Object.entries(POLICY_BODY_TYPE_RULES).reduce((acc, [policyPrefix, bodyTypes]) => {
    acc[policyPrefix] = new Set(bodyTypes.map(type => type.toLowerCase()));
    return acc;
}, {});

/**
 * Body types allowed for private car policies (non-commercial)
 */
export const PRIVATE_CAR_BODY_TYPES_SET = new Set([
    'Convertible',
    'Coupe',
    'Hatchback',
    'Sedan',
    'Station Wagon',
    'SUV',
    'Wagon'
].map(type => type.toLowerCase()));

/**
 * Default market value range for policies without specific requirements
 */
export const DEFAULT_MARKET_VALUE_RANGE = { min: 400001, max: 20000000 };

/**
 * Policy prefixes for private car insurance
 * Used to determine if private car body type restrictions apply
 */
export const PRIVATE_CAR_PREFIXES = [
    "MPCC", "MPCCS", "MUWC", "MPRC", // Comprehensive
    "MPCTP", "MPCTPS"               // Third-Party
];

/**
 * Policy prefixes for commercial vehicle insurance
 */
export const COMMERCIAL_PREFIXES = ['MCOC', 'MCOCS', 'MCPC', 'MCOTP', 'MCOTPS', 'MCPTP'];

// ============================================================================
// VEHICLE FORM OPTIONS & DROPDOWNS
// ============================================================================

/**
 * Fuel type options for vehicle selection
 */
export const FUEL_TYPE_OPTIONS = [
    { value: "Gasoline", label: "Petrol" },
    { value: "Diesel", label: "Diesel" },
    { value: "Hybrid", label: "Hybrid" },
    { value: "Electric", label: "Electric" }
];

/**
 * Transmission type options
 */
export const TRANSMISSION_TYPE_OPTIONS = [
    { value: "Automatic", label: "Automatic" },
    { value: "Semi-Automatic", label: "Semi-Automatic" },
    { value: "Standard", label: "Standard" }
];

/**
 * Vehicle import type options
 */
export const IMPORT_TYPE_OPTIONS = [
    { value: "Japanese/Asian Domestic", label: "Japanese/Asian Domestic" },
    { value: "Local Dealer", label: "Local Dealer" },
    { value: "Other", label: "Other" }
];

/**
 * Vehicle purchase location options
 */
export const VEHICLE_PURCHASE_OPTIONS = [
    { value: 'Local New Car Dealership', label: 'Local New Car Dealership' },
    { value: 'Pre-Owned (already registered in Jamaica)', label: 'Pre-Owned (already registered in Jamaica)' },
    { value: 'Used Car Dealer with vehicle NOT YET Registered in Jamaica', label: 'Used Car Dealer with vehicle NOT YET Registered in Jamaica' }
];

/**
 * Maximum number of seats for body type selection
 */
export const MAXIMUM_VEHICLE_SEATS = 9;

/**
 * Generate seat number options (1 to MAXIMUM_VEHICLE_SEATS)
 * @returns {Array<{value: string, label: string}>}
 */
export const generateSeatOptions = () => {
    const options = [];
    for (let i = 1; i <= MAXIMUM_VEHICLE_SEATS; i++) {
        options.push({ value: i.toString(), label: i.toString() });
    }
    return options;
};

// ============================================================================
// VEHICLE VALIDATION MESSAGES
// ============================================================================

/**
 * Error message for electric vehicles older than current year
 */
export const ELECTRIC_VEHICLE_RESTRICTION_MESSAGE = 
    "We're sorry, unfortunately, we are unable to provide coverage for electric vehicles older than the current year.";

/**
 * Error message when policy requirements are not met
 */
export const POLICY_NOT_QUALIFIED_MESSAGE = 
    "This vehicle is not qualified for this policy type.";

/**
 * Error message when body type is incompatible with policy
 */
export const BODY_TYPE_POLICY_ERROR_MESSAGE = 
    "Selected body type is not supported for this policy type.";

/**
 * Error message for driver license and vehicle body type mismatch
 */
export const VEHICLE_BODY_LICENSE_MISMATCH_MESSAGE = 
    "The selected vehicle body type is not compatible with the driver's license type.";

/**
 * Generate market value validation message based on range
 * @param {number} min - Minimum value
 * @param {number} max - Maximum value
 * @returns {string}
 */
export const getMarketValueValidationMessage = (min, max) => {
    const formatNumber = (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `Estimated Market Value must be between $${formatNumber(min)} and $${formatNumber(max)}.`;
};

// ============================================================================
// VEHICLE VALIDATION RANGES
// ============================================================================

/**
 * CC rating minimum value for validation
 */
export const MIN_CC_RATING = 3;

/**
 * Laden weight range for commercial vehicles (in kg)
 */
export const LADEN_WEIGHT_RANGE = { min: 1000, max: 6500 };

/**
 * Chassis number validation
 */
export const CHASSIS_NUMBER_VALIDATION = {
    minLength: 1,
    maxLength: 17,
    pattern: /^[A-Z0-9]+$/i
};

/**
 * Engine number validation
 */
export const ENGINE_NUMBER_VALIDATION = {
    maxLength: 17,
    pattern: /^[A-Z0-9]+$/i
};

/**
 * Maximum vehicle age in years (for vehicles older than 20 years)
 */
export const MAXIMUM_VEHICLE_AGE_YEARS = 20;

// ============================================================================
// DRIVER LICENSE VALIDATION
// ============================================================================

/**
 * Motor cycle license types (case-insensitive)
 */
export const MOTOR_CYCLE_LICENSE_TYPES = [
    "motor cycle",
    "motor cycles",
    "motor cycles only",
    "m/cycle",
    "class a"
];

/**
 * Motor car license types (case-insensitive)
 */
export const MOTOR_CAR_LICENSE_TYPES = [
    "private",
    "class b",
    "class c",
    "general"
];

/**
 * Valid car body types for motor car licenses
 */
export const VALID_CAR_BODY_TYPES = [
    "sedan",
    "hatchback",
    "hatch back",
    "coupe",
    "stn/waggon",
    "station wagon",
    "suv"
];

/**
 * Valid car and truck body types for general licenses
 */
export const VALID_CAR_TRUCK_BODY_TYPES = [
    "sedan",
    "hatchback",
    "hatch back",
    "coupe",
    "stn/waggon",
    "station wagon",
    "suv",
    "box",
    "truck",
    "pickup",
    "van"
];

/**
 * License description patterns from TAJ system
 * Used to match against "Licensed to Drive" strings from driver's license data
 * All values normalized to lowercase for case-insensitive comparison
 */
export const LICENSE_DESCRIPTION_PATTERNS = {
    MOTOR_CYCLES_ONLY: "m/cycles only",
    MOTOR_CARS_ONLY: "motor cars only",
    MOTOR_CARS_AND_TRUCKS: "motor cars & trucks",
    MOTOR_CARS_AND_TRUCKS_ABBREVIATED: "m/cars & truck",
    NET_WEIGHT_INDICATOR: "n/e"
};

// ============================================================================
// COMMERCIAL DRIVER LICENSE VALIDATION
// ============================================================================

/**
 * Policy prefixes that require commercial driver license validation
 * Used to determine if commercial license validation should be performed
 */
export const COMMERCIAL_POLICY_PREFIXES = new Set([
    'MCOC',  // Commercial Open
    'MCOTP', // Commercial Open Third Party
    'MPRCC', // Motor Passenger Road Commercial
    'MUWCC'  // Motor Utility/Wagon Commercial
]);

/**
 * Commercial vehicle body types that require driver license validation
 * All values normalized to lowercase for case-insensitive comparison
 */
export const COMMERCIAL_BODY_TYPES = new Set([
    'Box',
    'Van',
    'Window Van',
    'Pickup',
    'Minibus',
    'Bus',
    'Drop Side',
    'Stone',
    'Panel Van',
    'Tipper',
    'Truck',
    'Stake',
    'Tank',
    'Cargo',
    'Flat Bed',
    'Dump',
    'Tractor Head',
    'Crane',
    'Tanker',
    'Mini Van',
    'Bucket Truck',
    'Bucket Crane',
    'Backhoe',
    'Trailer',
    'Wrecker',
    'Refrigerator',
    'Mixer',
    'Bottle Rack',
    'Compactor',
    'Garbage Compactor',
    'Tractor',
    'Tow Truck',
    'Agri Tractor',
    'Double Cab'
].map(type => type.toLowerCase()));

/**
 * Valid driver license classes for commercial vehicles
 * Includes variations: "private" (likely B), "general" (likely G), and explicit class codes
 * All values normalized to lowercase for case-insensitive comparison
 */
export const VALID_COMMERCIAL_LICENSE_CLASSES = new Set([
    'b', 'c', 'p', 'g',
    'class b', 'class c', 'class p', 'class g',
    'private', // Often equivalent to Class B
    'general'  // Often equivalent to Class G
]);

/**
 * Commercial driver license validation error configuration
 * Used when driver's license is not valid for commercial vehicle
 */
export const COMMERCIAL_LICENSE_VALIDATION_ERROR = {
    title: "Vehicle is not Eligible for the Assigned Driver.",
    message: "Your Driver's Licence isn't valid for this vehicle. Please select 'Get a Quote' to continue for a new policy.",
    showQuoteCta: true
};